module.exports = __webpack_public_path__ + "static/media/spam-active.3a8e3943.svg";